import { View, Text } from 'react-native'
import { styles } from '@/src/common/modules/OnboardingChecklist/styles'
import { useMesaCardPlaidChecklistItem } from '@/src/common/modules/OnboardingChecklist/MesaCardPlaidChecklistItem'
import { useBenefitsChecklistItem } from '@/src/common/modules/OnboardingChecklist/BenefitsChecklistItem'
import { ExclusePointsCategoriesChecklistItem } from '@/src/common/modules/OnboardingChecklist/ExclusePointsCategoriesChecklistItem'
import type { ComponentProps } from 'react'
import { DesignSystem } from '@/src/design-system'
import { Loading } from '@/src/common/components/Loading'
import { typography } from '@/src/common/theme'
import * as MortgageEarn from '@/src/experiences/mortgage-earn'
import { HomeE2E } from '@/src/experiences/home/e2e'

export function OnboardingChecklist({
  style,
}: Pick<ComponentProps<typeof DesignSystem.Card>, 'style'>) {
  const mesaHomeAwardChecklistComponent = MortgageEarn.Hooks.useOnboardingChecklistComponent()
  const mesaCardPlaidChecklistItem = useMesaCardPlaidChecklistItem()
  const benefitsChecklistItem = useBenefitsChecklistItem()
  const mesaHomeCardSpendChecklistItem = MortgageEarn.Hooks.useProgressChecklistComponent()

  return (
    <DesignSystem.Card
      style={[{ padding: 0, paddingBottom: 16 }, style]}
      testID={HomeE2E.Ids.View.OnboardingChecklist}
    >
      <View style={styles.headerTitle}>
        <Text style={typography['heading/heading4']}>Mesa Hub</Text>
      </View>
      {(() => {
        switch ('loading') {
          case mesaHomeAwardChecklistComponent:
          case mesaCardPlaidChecklistItem:
          case benefitsChecklistItem:
          case mesaHomeCardSpendChecklistItem:
            return <Loading />
          default:
            return (
              <>
                {mesaHomeAwardChecklistComponent}
                {mesaCardPlaidChecklistItem}
                {benefitsChecklistItem}
                <ExclusePointsCategoriesChecklistItem />
                {mesaHomeCardSpendChecklistItem}
              </>
            )
        }
      })()}
    </DesignSystem.Card>
  )
}
